"use client";

import { c as _c } from "react/compiler-runtime";
import { HospitalReview, TreatmentCaseCarousel, TreatmentSubjectAnalysis } from "@/widgets/hospital/ui/organisms";
import { useTranslations } from "next-intl";
const ReviewTabContent = () => {
  const $ = _c(9);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("reviewTabContent.sectionLabel");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h2 className="sr-only">{t0}</h2>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TreatmentSubjectAnalysis />;
    t3 = <TreatmentCaseCarousel />;
    t4 = <HospitalReview />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = <section>{t1}{t2}{t3}{t4}</section>;
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default ReviewTabContent;